import {Stack} from "@mui/material"
import ShimmerText from "../ShimmerText";

const Home = () => {
    return (
        <Stack direction="column" padding="40px">
            <ShimmerText>
                Lucrăm la site...
            </ShimmerText>
        </Stack>
    )
}

export default Home;